import { useMutation, useQuery } from 'react-query';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';
import useInjection from 'hooks/useInjection';

export const useUserAnalytics = () => {
  const userProfileService = useInjection(
    SERVICE_IDENTIFIER.UserProfileService,
  );

  return useQuery({
    queryKey: ['user_analytics'],
    queryFn: () => userProfileService.getUserAnalytics(),
  });
};

export const useAccountData = () => {
  const userProfileService = useInjection(
    SERVICE_IDENTIFIER.UserProfileService,
  );

  return useQuery({
    queryKey: ['user_account'],
    queryFn: () => userProfileService.getAccountData(),
  });
};

export const useFullNameUser = () => {
  const { data, isLoading, isError, status } = useAccountData();
  let fullName = '';
  if (isLoading) fullName = 'Звгружается...';
  if (isError) fullName = 'Ошибка при загрузке данных';
  fullName = `${data?.name?.first ?? ''} ${data?.name?.last ?? ''}`;

  return { fullName, status };
};

export const useSendSalesPlans = () => {
  const userProfileService = useInjection(
    SERVICE_IDENTIFIER.UserProfileService,
  );

  return useMutation((data: { profit: number; revenue: number }) => {
    return userProfileService.sendSalesPlans(data);
  });
};
